/* eslint-disable react/no-array-index-key */
import { ReactNode } from "react";
import Button from "../Button";
import { Heading } from "../Type";
import styles from "./index.module.scss";

type PropsType = {
  title: string;
  sections: {
    title?: string;
    content: { label: string; value: ReactNode }[];
  }[];
  headingAction?: {
    title: string;
    onClick: () => void;
    disabled?: boolean;
  };
};

const InfoCard = ({ title, sections, headingAction }: PropsType) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <Heading size="h5">{title}</Heading>
        {headingAction && (
          <Button secondary onClick={() => headingAction.onClick()} disabled={headingAction.disabled}>
            {headingAction.title}
          </Button>
        )}
      </div>
      <div className={styles.content}>
        {sections.map((c, i) => (
          <div
            key={`${title.toLowerCase().replace(" ", "-")}-section-${i}`}
            className={styles.section}
          >
            {c.title && (
              <Heading size="h5" className={styles.sectionHeader}>
                {c.title}
              </Heading>
            )}
            <dl className={styles.list}>
              {c.content.map((c, y) => (
                <div
                  key={`${title
                    .toLowerCase()
                    .replace(" ", "-")}-section-${i}-content-${y}`}
                  className={styles.listRow}
                >
                  <dt>{c.label}</dt>
                  <dd>{c.value}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoCard;
